import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import { useAuth } from "../AuthContext";
import iziToast from "izitoast";
import Footer from "./Footer";

export const AddExam = () => {
    const [activeTab, setActiveTab] = useState("Exam");
    const { apipath, logout, goBack } = useAuth();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [isLoading, setIsLoading] = useState(false);
    const [totalQuestions, setTotalQuestions] = useState(0);
    const [school, setSchool] = useState('');
    const [examName, setExamName] = useState('');
    const [subjects, setSubjects] = useState([{ subject: '', questions: '' }]);
    const [error, setError] = useState('');
    const [organizations, setOrganizations] = useState([]);

    useEffect(() => {
        const getOrganizations = async () => {
            try {
                const response = await axios.post(
                    apipath + '/organizations',
                    {},
                    {
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    }
                );
                console.log(response.data);
                if (response.data.status === "unauthentic") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    logout();
                }
                if (response.data.status === "false") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                }
                setOrganizations(response.data.organizations);
            }
            catch (error) {
                // console.error('Error fetching data:', error);
                if (error.status === 401) {
                    iziToast.error({
                        message: "Un-Authorised! Please Login.",
                        position: "topCenter"
                    });
                    logout();
                }
                else {
                    iziToast.error({
                        message: error,
                        position: 'topCenter'
                    });
                }

            } finally {

            }
        }
        getOrganizations();
    }, []);

    const handleAddSubject = () => {
        setSubjects([...subjects, { subject: '', questions: '' }]);
    };

    const handleRemoveSubject = (index) => {
        const updatedSubjects = subjects.filter((_, i) => i !== index);
        setSubjects(updatedSubjects);
    };

    const handleInputChange = (index, field, value) => {
        const updatedSubjects = subjects.map((subject, i) =>
            i === index ? { ...subject, [field]: value } : subject
        );
        setSubjects(updatedSubjects);
    };

    // Update the total questions whenever subjects change
    useEffect(() => {
        const total = subjects.reduce((sum, subject) => sum + (parseInt(subject.questions) || 0), 0);
        setTotalQuestions(total);
    }, [subjects]);

    const validateForm = () => {
        // Check if school and exam name are filled
        if (!school || school.trim() === "") {
            setError('Please select an organization');
            return false;
        }
        if (!examName || examName.trim() === "") {
            setError('Please enter an exam name');
            return false;
        }

        // Check if all subjects and questions are filled
        for (let i = 0; i < subjects.length; i++) {
            if (!subjects[i].subject || subjects[i].subject.trim() === "") {
                setError(`Please enter a subject for row ${i + 1}`);
                return false;
            }
            if (!subjects[i].questions || subjects[i].questions === "0") {
                setError(`Please enter the number of questions for subject ${i + 1}`);
                return false;
            }
        }

        setError(''); // Clear any previous errors if validation passes
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            // Handle form submission logic
            // console.log('Exam created:', { school, examName, subjects });
            const formData = {
                'organization': school,
                'exam_name': examName,
                'subjects': subjects,
                'total_questions': totalQuestions,
            }
            setIsLoading(true);
            try {
                const response = await axios.post(
                    apipath + '/add_exam', formData,
                    {
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    }
                );
                // console.log(response.data);
                if (response.data.status === "unauthentic") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    logout();
                }
                if (response.data.status === "false") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                }
                else {
                    iziToast.success({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    navigate('/exams');
                }
            }
            catch (error) {
                // console.error('Error fetching data:', error);
                if (error.status === 401) {
                    iziToast.error({
                        message: "Un-Authorised! Please Login.",
                        position: "topCenter"
                    });
                    logout();
                }
                else {
                    iziToast.error({
                        message: error,
                        position: 'topCenter'
                    });
                }
            }
            finally {
                setIsLoading(false);
            }
        }
    };


    return (
        <>
            <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center fixed top-0 left-0 w-full h-screen z-50" : "hidden"}>
                <svg
                    className="w-5 h-5 mr-2 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
                    ></path>
                </svg>
                Loading...
            </span>
            {<Navbar />}
            <div class="flex flex-col md:flex-row">
                {<Sidebar activePage={"exams"} />}
                <div class="main-content flex-1 bg-gray-100 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">

                    <div class="bg-teal-700 pt-4">
                        <div class="rounded-tl-3xl bg-teal-600 p-2 justify-between shadow text-2xl text-white flex flex-col md:flex-row relative">
                            <span class="font-bold pl-2">
                                <i className="fa fa-arrow-left text-sm border-2 rounded absolute right-3 py-1 px-2 top-2 bg-teal-700 hover:bg-teal-800 cursor-pointer" title="go back" onClick={() => goBack()}></i>Add Exam</span>
                            {/* <div className="flex flex-row mt-4 md:mt-0">
                                <Link to={`/exams`}><span class={`md:ml-5 ml-2 ${activeTab === 'Exam' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Exams
                                </span></Link>
                                <Link to={`/tests`}><span class={`md:ml-5 ml-2 ${activeTab === 'Test' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Tests
                                </span></Link>
                            </div> */}
                        </div>
                        {/* <div class="bg-gradient-to-r from-cyan-900 to-cyan-900 px-4 py-2 shadow text-base text-white">
                            <h3 class="font-medium pl-2">Users</h3>
                        </div> */}
                    </div>

                    <div class="flex flex-wrap">
                        <div class="w-full p-2">
                            {/* <h2 class="mb-3 text-xl font-semibold">Add Student</h2> */}
                            <form onSubmit={handleSubmit} className=" mx-auto p-4 space-y-6 bg-white rounded-lg shadow-lg">
                                <h2 className="text-2xl font-bold text-teal-800 text-center">Create Exam</h2>

                                {/* Error Message */}
                                {error && <div className="text-red-500 text-sm">{error}</div>}

                                <div className="flex flex-col md:flex-row">
                                    {/* School Name */}
                                    <div className="w-full md:w-1/2 pe-4">
                                        <label className="block text-sm font-medium text-gray-700">Select Organization Name</label>
                                        <select
                                            value={school}
                                            onChange={(e) => setSchool(e.target.value)}
                                            className="mt-1 block w-full p-2 border rounded-md"
                                            required
                                        >
                                            <option value={""}>Select Organization</option>
                                            {organizations.map((org) => {
                                                return (<>
                                                    <option value={org.id}>{org.name}</option>
                                                </>)
                                            })}
                                        </select>
                                    </div>

                                    {/* Exam Name */}
                                    <div className="w-full md:w-1/2">
                                        <label className="block text-sm font-medium text-gray-700">Exam Name</label>
                                        <input
                                            type="text"
                                            value={examName}
                                            onChange={(e) => setExamName(e.target.value)}
                                            className="mt-1 block w-full p-2 border rounded-md"
                                            placeholder="Enter Exam Name"
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Subjects and Number of Questions */}
                                {subjects.map((subject, index) => (
                                    <div key={index} className="flex items-center space-x-4">
                                        <div className="w-1/2">
                                            <label className="block text-sm font-medium text-gray-700">Subject</label>
                                            <input
                                                type="text"
                                                value={subject.subject}
                                                onChange={(e) => handleInputChange(index, 'subject', e.target.value)}
                                                className="mt-1 block w-full p-2 border rounded-md"
                                                placeholder="Enter Subject"
                                                required
                                            />
                                        </div>
                                        <div className="w-1/2">
                                            <label className="block text-sm font-medium text-gray-700">Number of Questions</label>
                                            <input
                                                type="number"
                                                value={subject.questions}
                                                onChange={(e) => handleInputChange(index, 'questions', e.target.value)}
                                                className="mt-1 block w-full p-2 border rounded-md"
                                                placeholder="Enter No. of Questions"
                                                min={1}
                                                required
                                            />
                                        </div>
                                        <button type="button" onClick={() => handleRemoveSubject(index)} className="text-red-500 hover:text-red-700" >
                                            <i className="fa fa-times"></i>
                                        </button>
                                    </div>
                                ))}

                                {/* Add Subject Button */}
                                <div className="text-right">
                                    <button
                                        type="button"
                                        onClick={handleAddSubject}
                                        className="bg-teal-500 text-white px-4 py-2 text-sm rounded-md hover:bg-teal-600"
                                    >
                                        Add Subject
                                    </button>
                                </div>

                                <div className="flex flex-col md:flex-row">
                                    {/* School Name */}
                                    <div className="w-full md:w-1/2 pe-4">
                                        <label className="block text-sm font-medium text-gray-700">Total Questions</label>
                                        <input
                                            value={totalQuestions}
                                            onChange={(e) => setTotalQuestions(e.target.value)}
                                            className="mt-1 block w-full p-2 border rounded-md" disabled />
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <div className="text-center">
                                    <button type="submit" className="bg-teal-500 text-white px-6 py-2 rounded-md hover:bg-teal-600">
                                        Create Exam
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};